import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const Bubbles = ({primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <circle className={secondaryClassName} cx="16" cy="16" r="2.5" />
        <circle className={primaryClassName} cx="8.5" cy="16" r="2.5" />
        <circle className={tertiaryClassName} cx="23.5" cy="16" r="2.5" />
    </svg>
);

export default Bubbles;
